export const getCurrentUser = state => {
    if (state.currentUser.id) {
        const { users } = state.db;
        return users[state.currentUser.id];
    }
    return undefined;
};

export const getIsLoadingCurrentUser = state => !!state.currentUser.loading;



// WEBPACK FOOTER //
// ./src/selectors/userSelectors.js